/**
 * Orca Projects List route — eagerly registers the route + `beforeLoad`
 * SSR loader but defers component + atom imports via `.lazy.tsx`. This
 * keeps the orca admin chunk out of the bundle for non-admin users on
 * every other route. The orcaloops frame's sheet the lazy chunk's markup
 * depends on comes from `head()` here, as a `?url` link.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { orcaProjectsBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The route's `head()`: the orcaloops frame's sheet. Extracted so it is
 * unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const projectsHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/projects/")({
  beforeLoad: orcaProjectsBeforeLoad,
  head: projectsHead,
});
